const FolderIcon = ({ width = 55, height = 55, fill = "var(--primary)" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 64 48"
      fill="none"
    >
      <path
        d="M6 10C6 6.68629 8.68629 4 12 4H24C26.2 4 28.2 5.2 29.2 7L30.4 9.2C31 10.3 32.1 11 33.4 11H52C55.3137 11 58 13.6863 58 17V18H6V10Z"
        fill="#9F67FF"
      />

      <path
        d="M6 18H58V38C58 41.3137 55.3137 44 52 44H12C8.68629 44 6 41.3137 6 38V18Z"
        fill={fill}
      />

      <path d="M6 18H58V22H6V18Z" fill="#B794FF" opacity="0.45" />

      <path
        d="M6 36C6 40.4183 9.58172 44 14 44H50C54.4183 44 58 40.4183 58 36V38C58 41.3137 55.3137 44 52 44H12C8.68629 44 6 41.3137 6 38V36Z"
        fill="#5B21B6"
        opacity="0.35"
      />
    </svg>
  );
};

export default FolderIcon;
